module.exports = __webpack_public_path__ + "img/image-home.20a066c2.jpg";